import React from "react";
import styled, { withTheme } from "styled-components";
import moment from "moment";
import { getTimeFormat } from "../../../helpers/timeHelper";

const StyledDiv = styled.div`
  min-height: 2em;
  border-radius: 5px;
  margin-top: 10px;
  background-color: ${(props) => props.theme?.whiteSmoke};
  padding-top: 0.2em;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  > div {
    display: flex;
    flex-direction: row;
    justify-content: inherit;
    padding-right: 5px;
    padding-left: 0;
    width: unset;

    @media (max-width: 647px) {
      .col-sm-1 {
        max-width: 45px;
      }
    }
  }
`;

const StyledActions = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: auto;
  margin-bottom: auto;
`;

const StyledFirstCol = styled.div`
  flex: 1;
  min-width: 0;
  margin-right: 20px;
`;

const StyledLastCol = styled.div`
  text-align: end;
`;

const DeleteButton = styled.span`
  color: ${(props) => props.theme?.gray};
  font-size: 1rem;
  cursor: pointer;
  vertical-align: middle;
  margin-right: 10px;
`;

const EditButton = styled.span`
  color: ${(props) => props.theme?.darkPurple};
  font-size: 1rem;
  cursor: pointer;
  vertical-align: middle;
`;

const StyledText = styled.div`
  cursor: pointer;
  margin-right: auto;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 300px;
  &:hover {
    text-decoration: underline;
  }
`;

const CompleteIcon = styled.i`
  color: ${(props) => props?.theme?.lightGreen};
  font-size: 20px;
`;

const StyledElement = (props) => {
  const {
    index,
    element,
    onEdit,
    canEdit,
    onDelete,
    canDelete,
    completed,
    timeFormat = "12h",
  } = props;

  return (
    <StyledDiv
      data-testid="entry-record"
      className="row"
      key={`styled-index-${index}`}
    >
      <StyledFirstCol>
        <StyledActions className="text-center mx-3 px-0">
          {canDelete && (
            <DeleteButton
              data-testid={`delete-button-${index}`}
              className="fas fa-trash"
              onClick={(e) => onDelete(element)}
            />
          )}
          {canEdit && (
            <EditButton
              data-testid={`edit-button-${index}`}
              className="fas fa-pencil-alt"
              onClick={(e) => onEdit(element)}
            />
          )}
          {completed && (
            <span className="align-middle">
              <CompleteIcon className="fas fa-check-circle" />
            </span>
          )}
        </StyledActions>

        <StyledText
          data-testid={`view-button-${index}`}
          onClick={(e) =>
            onEdit({
              ...element,
              readOnly: true,
            })
          }
        >
          {element.title}
        </StyledText>
      </StyledFirstCol>
      <StyledLastCol>
        {moment(element.date).format(getTimeFormat(timeFormat))}
      </StyledLastCol>
    </StyledDiv>
  );
};

export default withTheme(StyledElement);
